var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BehaviorSubject, timer } from 'rxjs';
import { ErrorService } from './error.service';
var BrowserErrorService = /** @class */ (function (_super) {
    __extends(BrowserErrorService, _super);
    function BrowserErrorService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentErrorMap = {};
        _this._allErrorsSubject = new BehaviorSubject([]);
        _this.allErrors = _this._allErrorsSubject.asObservable();
        return _this;
    }
    BrowserErrorService.prototype._emitMapAsArray = function () {
        var _this = this;
        var arr = Object.keys(this._currentErrorMap).map(function (key) { return ({
            msgKey: key,
            code: _this._currentErrorMap[key].code
        }); });
        this._allErrorsSubject.next(arr);
    };
    BrowserErrorService.prototype._clearAfter = function (errorKey, seconds) {
        var _this = this;
        return timer(seconds * 1000).subscribe(function () {
            delete _this._currentErrorMap[errorKey];
            _this._emitMapAsArray();
        });
    };
    BrowserErrorService.prototype.clearError = function (errorKey, emit) {
        if (emit === void 0) { emit = true; }
        if (this._currentErrorMap[errorKey] && this._currentErrorMap[errorKey].timerSub) {
            this._currentErrorMap[errorKey].timerSub.unsubscribe();
        }
        delete this._currentErrorMap[errorKey];
        if (emit)
            this._emitMapAsArray();
    };
    BrowserErrorService.prototype.clearAllErrors = function () {
        var _this = this;
        Object.keys(this._currentErrorMap).forEach(function (key) { return _this.clearError(key, false); });
        this._emitMapAsArray();
    };
    /**
     * @param errorKey error translation key
     * @param code any error code that might be returned from server to give extra context.
     * @param secondsToDisplay clear this error from screen after X seconds
     */
    BrowserErrorService.prototype.displayError = function (errorKey, code, secondsToDisplay) {
        if (!this._currentErrorMap[errorKey]) {
            this._currentErrorMap[errorKey] = { code: code };
            if (secondsToDisplay)
                this._currentErrorMap[errorKey].timerSub = this._clearAfter(errorKey, secondsToDisplay);
        }
        else if (this._currentErrorMap[errorKey].timerSub && secondsToDisplay) {
            this._currentErrorMap[errorKey].timerSub.unsubscribe();
            this._currentErrorMap[errorKey].timerSub = this._clearAfter(errorKey, secondsToDisplay);
        }
        this._emitMapAsArray();
    };
    return BrowserErrorService;
}(ErrorService));
export { BrowserErrorService };
